/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {
    export class ApiActionService extends DataService<Wars.Domain.Model.ApiAction>{

        constructor(breeze: any, $q: angular.IQService, private $http: angular.IHttpService) {
            super(breeze, $q);
        }

        public getApiActions(processConfigurationId: string): angular.IPromise<Wars.Domain.Model.ApiAction[]> {
            var expand = "objectQuery.myInputObjectSchema, " +
                "objectQuery.myProjectionObjectSchema, " +
                "inputObjectSchema.properties, " +
                "outputObjectSchema.properties, " +
                "apiSchemaMappings";

            const query = this.breezeModule.EntityQuery
                .from("ApiActions")
                .where('processConfiguration_id', '==', processConfigurationId)
                .expand(expand);

            return this.executeQuery(query);
        }

        public runApiAction(processTypeId: string, apiActionId: string): angular.IPromise<any> {
            var d = this.$q.defer();

            this.$http.post('./api/ApiAction/' + apiActionId + "/ProcessType/" + processTypeId, null).then(r => {
                d.resolve(r.data);
            });

            return d.promise;
        }

        public getApiConfigurations(): angular.IPromise<Wars.Domain.Model.ApiAction[]> {
            //console.log('api');
            const query = this.breezeModule.EntityQuery
                .from("ApiActions")
                .where('isActive', '==', true)
                .expand("inputObjectSchema.properties, outputObjectSchema.properties, processConfiguration.myProcessType");

            return this.executeQuery(query);
        }

        public getApiActionForField(uniqueId): angular.IPromise<Wars.Domain.Model.ApiAction[]> {
            var p1 = new breeze.Predicate('isActive', '==', true);
            var p2 = new breeze.Predicate('uniqueId', '==', uniqueId);
            var pred = breeze.Predicate.and([p1, p2]);

            const query = this.breezeModule.EntityQuery
                .from("ApiActions")
                .where(pred)
                .expand("outputObjectSchema.properties");

            return this.executeQuery(query);
        }

        public createApiAction(): Wars.Domain.Model.ApiAction {
            let apiAction = <Wars.Domain.Model.ApiAction>this.createNewEntity("ApiAction");
            apiAction.uniqueId = services.UtilityService.generateGuidComb();

            return apiAction;
        }
    }
}

warsApp.registerService('ApiActionService', ['breeze', '$q', '$http']);
